export default __webpack_public_path__ + "static/media/icon_phone.3e1c3441.svg";